class agri_experts {
    constructor() {
const WEBDOCHOMECONTENTINSDAILY1 = "WEBDOCHOMECONTENTINSDAILY1";
const WEBDOCHOMECONTENTINSDAILY2 = "WEBDOCHOMECONTENTINSDAILY2";
      this.items = [
        {
          serviceId: 1,
          pid: WEBDOCHOMECONTENTINSDAILY1,
          name: "WebdocHomeContentInsDaily1",
          serviceName:"Home Content Insurance",
          badge: "Silver",
          coverage: "100,000",
          price:"12",
          bgColorClass: "bg-info",
          description: `<p><strong>Home Content Insurance</strong> is an exciting product that provides good value to Jazz customers who get financial protection for Home Content.</p>
<ul>
<li><strong>Total Coverage: </strong>Up to Rs. 100,000</li>
<li><strong>Waiting Period:</strong> 14 days</li>
<li><strong>Subscription:</strong> Daily</li>
<li>20% deductible apply</li>
</ul>
<p><strong>Claims:</strong></p>
<ul>
<li>Make your claim within 15 (fifteen) days of the theft/burglary</li>
<li>Settled directly with the claimants within 3 working days of document submission</li>
<li>End-to-end support and handholding to claimant</li>
<li>Police report required</li>
</ul>`,
            type: "home",
        },
        {
          serviceId: 2,
          pid: WEBDOCHOMECONTENTINSDAILY2,
          name: "WebdocHomeContentInsDaily2",
          serviceName:"Home Content Insurance",
          badge: "Gold",
          coverage: "200,000",
          price:"20.5",
          bgColorClass: "bg-warning",
          description: `<p><strong>Home Content Insurance</strong> is an exciting product that provides good value to Jazz customers who get financial protection for Home Content.</p>
<ul>
<li><strong>Total Coverage: </strong>Up to Rs. 200,000</li>
<li><strong>Waiting Period:</strong> 14 days</li>
<li><strong>Subscription:</strong> Daily</li>
<li>20% deductible apply</li>
</ul>
<p><strong>Claims:</strong></p>
<ul>
<li>Make your claim within 15 (fifteen) days of the theft/burglary</li>
<li>Settled directly with the claimants within 3 working days of document submission</li>
<li>End-to-end support and handholding to claimant</li>
<li>Police report required</li>
</ul>`,
            type: "home",
        },
        
      ];
    }
  
    getAllItems() {
      return this.items;
    }
  }
  
  export default agri_experts;
  